// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-page-content {
    display: flex;
    min-height: 100%;
    gap: 50px;
    padding: 50px 20px;
    min-width: 100%;
    box-sizing: border-box;
    background-color: white;
}

.account-page-sidebar {
    position: sticky;
    top: calc(50px + var(--menuBarHeight)); /*menubar + 50px paddingtop of page*/
    height: -moz-fit-content;
    height: fit-content;
    box-sizing: border-box;
    z-index: 25;
    background-color: white;
}

@media screen and (max-width: 1000px) {
    .account-page-sidebar {
        display: none;
    }
    .account-page-main {
        width: 100% !important;
    }
}

.account-page-sidebar h3 {
    font-size: 30px;
    font-weight: 500;
    margin: 0;
    padding: 0;
    margin-bottom: 20px;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
}

h2 span {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

hr {
    width: 100%;
    margin: 0;
    padding: 0;
    border: 1px solid #00000020;
}

p {
    font-size: 16px;
}

.account-page-main {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 50px;
    position: relative;
    margin: 0 auto;
    width: min(90%, 1500px);
}
.account-page-main h2 {
    font-size: 36px;
    font-weight: 600;
    margin: 0;
    padding: 0;
    margin-bottom: 20px;
}

.section-container {
    display: flex;
    gap: 50px;
    align-items: center;
    justify-content: space-evenly;
}
@media (max-width: 1000px) {
    .section-container {
        flex-direction: column;
    }
}

.nowrap-selectall-btn {
    white-space: nowrap !important;
    width: -moz-fit-content !important;
    width: fit-content !important;
    overflow-x: visible !important;
}

.account-page-avatar {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex-grow: 1;
}
.account-page-profile-info, .password-reset-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex-grow: 1;
    width: 100%;
    box-sizing: border-box;
}

.hidden-input {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	cursor: pointer;
}

.past-payments-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/account/AccountPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,sCAAsC,EAAE,oCAAoC;IAC5E,wBAAmB;IAAnB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,mJAAmJ;AACvJ;;AAEA;IACI,WAAW;IACX,SAAS;IACT,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kCAA6B;IAA7B,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,sBAAsB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,UAAU;CACV,eAAe;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb","sourcesContent":[".account-page-content {\n    display: flex;\n    min-height: 100%;\n    gap: 50px;\n    padding: 50px 20px;\n    min-width: 100%;\n    box-sizing: border-box;\n    background-color: white;\n}\n\n.account-page-sidebar {\n    position: sticky;\n    top: calc(50px + var(--menuBarHeight)); /*menubar + 50px paddingtop of page*/\n    height: fit-content;\n    box-sizing: border-box;\n    z-index: 25;\n    background-color: white;\n}\n\n@media screen and (max-width: 1000px) {\n    .account-page-sidebar {\n        display: none;\n    }\n    .account-page-main {\n        width: 100% !important;\n    }\n}\n\n.account-page-sidebar h3 {\n    font-size: 30px;\n    font-weight: 500;\n    margin: 0;\n    padding: 0;\n    margin-bottom: 20px;\n    white-space: nowrap;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n}\n\nh2 span {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\nhr {\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    border: 1px solid #00000020;\n}\n\np {\n    font-size: 16px;\n}\n\n.account-page-main {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    gap: 50px;\n    position: relative;\n    margin: 0 auto;\n    width: min(90%, 1500px);\n}\n.account-page-main h2 {\n    font-size: 36px;\n    font-weight: 600;\n    margin: 0;\n    padding: 0;\n    margin-bottom: 20px;\n}\n\n.section-container {\n    display: flex;\n    gap: 50px;\n    align-items: center;\n    justify-content: space-evenly;\n}\n@media (max-width: 1000px) {\n    .section-container {\n        flex-direction: column;\n    }\n}\n\n.nowrap-selectall-btn {\n    white-space: nowrap !important;\n    width: fit-content !important;\n    overflow-x: visible !important;\n}\n\n.account-page-avatar {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    flex-grow: 1;\n}\n.account-page-profile-info, .password-reset-container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    flex-grow: 1;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.hidden-input {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\topacity: 0;\n\tcursor: pointer;\n}\n\n.past-payments-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
